import { isStringEmptyOrNull } from "../../../../utils/common";
import moment from 'moment';
import { MSG_EMPTY_REQUIRED, MSG_GREATER_ENDDATE, MSG_EXCEEDS_CHARACTER, MSG_INVALID_EMAIL, MSG_FIELD_NOT_NUMBER, MSG_INVALID_NUMBER } from "../../../../utils/messages";

export const validateForm = (values) => {

    let errors = {};

    if (isStringEmptyOrNull(values.MemberModel.lastName)) {
        errors[`MemberModel.lastName`] = MSG_EMPTY_REQUIRED;
    } else if (125 < values.MemberModel.lastName.length) {
        errors[`MemberModel.lastName`] = MSG_EXCEEDS_CHARACTER;
    }

    if (isStringEmptyOrNull(values.MemberModel.firstName)) {
        errors[`MemberModel.firstName`] = MSG_EMPTY_REQUIRED;
    } else if (125 < values.MemberModel.lastName.length) {
        errors[`MemberModel.firstName`] = MSG_EXCEEDS_CHARACTER;
    }

    if (isStringEmptyOrNull(values.MemberModel.middleName)) {
        errors[`MemberModel.middleName`] = MSG_EMPTY_REQUIRED;
    }
    else if (125 < values.MemberModel.middleName.length) {
        errors[`MemberModel.middleName`] = MSG_EXCEEDS_CHARACTER;
    }

    if (isStringEmptyOrNull(values.MemberModel.gender)) {
        errors[`MemberModel.gender`] = MSG_EMPTY_REQUIRED;
    }

    if (isStringEmptyOrNull(values.MemberModel.emailAddress)) {
        errors[`MemberModel.emailAddress`] = MSG_EMPTY_REQUIRED;
    } else if (125 < values.MemberModel.emailAddress.length) {
        errors[`MemberModel.emailAddress`] = MSG_EXCEEDS_CHARACTER;
    } else if (!/^\w+([-.]?\w+)*@\w+([-.]?\w+)*(\.\w{2,3})+$/.test(values.MemberModel.emailAddress)) {
        errors[`MemberModel.emailAddress`] = MSG_INVALID_EMAIL;
    }

    if (125 < values.MemberModel.faxNumber.length) {
        errors[`MemberModel.faxNumber`] = MSG_EXCEEDS_CHARACTER;
    } else if (!/^$|[-+()]*[0-9][-+()0-9]*$/.test(values.MemberModel.faxNumber)) {
        errors[`MemberModel.faxNumber`] = MSG_INVALID_NUMBER;
    }


    if (isStringEmptyOrNull(values.MemberModel.contactNumber)) {
        errors[`MemberModel.contactNumber`] = MSG_EMPTY_REQUIRED;
    } else if (!/^[- +()]*[0-9][- +()0-9]*$/.test(values.MemberModel.contactNumber)) {
        errors[`MemberModel.contactNumber`] = MSG_INVALID_NUMBER;
    }

    if (!/^$|[-+()]*[0-9][-+()0-9]*$/.test(values.MemberModel.contactNumber2)) {
        errors[`MemberModel.contactNumber2`] = MSG_INVALID_NUMBER;
    }

    if (isStringEmptyOrNull(values.MemberModel.company)) {
        errors[`MemberModel.company`] = MSG_EMPTY_REQUIRED;
    } else if (125 < values.MemberModel.company.length) {
        errors[`MemberModel.company`] = MSG_EXCEEDS_CHARACTER;
    }


    if (isStringEmptyOrNull(values.MemberModel.companyDescription)) {
        errors[`MemberModel.companyDescription`] = MSG_EMPTY_REQUIRED;
    } else if (225 < values.MemberModel.companyDescription.length) {
        errors[`MemberModel.companyDescription`] = MSG_EXCEEDS_CHARACTER;
    }

    if (isStringEmptyOrNull(values.MemberModel.industryId.toString())) {
        errors[`MemberModel.industryId`] = MSG_EMPTY_REQUIRED;
    }


    if (isStringEmptyOrNull(values.MemberModel.occupation)) {
        errors[`MemberModel.occupation`] = MSG_EMPTY_REQUIRED;
    } else if (125 < values.MemberModel.occupation.length) {
        errors[`MemberModel.occupation`] = MSG_EXCEEDS_CHARACTER;
    }

    if (isStringEmptyOrNull(values.MemberModel.address1)) {
        errors[`MemberModel.address1`] = MSG_EMPTY_REQUIRED;
    } else if (125 < values.MemberModel.address1.length) {
        errors[`MemberModel.address1`] = MSG_EXCEEDS_CHARACTER;
    }

    if (!isStringEmptyOrNull(values.MemberModel.address2) && 125 < values.MemberModel.address2.length) {
        errors[`MemberModel.address2`] = MSG_EXCEEDS_CHARACTER;
    }

    if (isStringEmptyOrNull(values.MemberModel.city)) {
        errors[`MemberModel.city`] = MSG_EMPTY_REQUIRED;
    } else if (125 < values.MemberModel.city.length) {
        errors[`MemberModel.city`] = MSG_EXCEEDS_CHARACTER;
    }
    if (isStringEmptyOrNull(values.MemberModel.stateProvince)) {
        errors[`MemberModel.stateProvince`] = MSG_EMPTY_REQUIRED;
    } else if (125 < values.MemberModel.stateProvince.length) {
        errors[`MemberModel.stateProvince`] = MSG_EXCEEDS_CHARACTER;
    }

    if (11 < values.MemberModel.zipCode.length) {
        errors[`MemberModel.zipCode`] = MSG_EXCEEDS_CHARACTER;
    } else if (isNaN(values.MemberModel.zipCode)) {
        errors[`MemberModel.zipCode`] = MSG_FIELD_NOT_NUMBER;
    }

    if (isStringEmptyOrNull(values.MemberModel.country)) {
        errors[`MemberModel.country`] = MSG_EMPTY_REQUIRED;
    }

    if (moment(values.MemberModel.subscriptionEndDate).isBefore(moment(values.MemberModel.subscriptionStartDate))) {
        errors[`MemberModel.subscriptionEndDate`] = MSG_GREATER_ENDDATE;
    }

    console.log(errors)

    return errors;

}